"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendQueuedEvents = void 0;
const get_zaraz_1 = require("../helpers/get-zaraz");
/**
 * If some Pageview-based events were not sent due to a lack of consent, they can be sent using this method after consent was granted.
 */
function sendQueuedEvents() {
    (0, get_zaraz_1.getZaraz)().consent.sendQueuedEvents();
}
exports.sendQueuedEvents = sendQueuedEvents;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VuZC1xdWV1ZWQtZXZlbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnNlbnQvc2VuZC1xdWV1ZWQtZXZlbnRzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG9EQUFnRDtBQUVoRDs7R0FFRztBQUNILFNBQWdCLGdCQUFnQjtJQUM5QixJQUFBLG9CQUFRLEdBQUUsQ0FBQyxPQUFPLENBQUMsZ0JBQWdCLEVBQUUsQ0FBQztBQUN4QyxDQUFDO0FBRkQsNENBRUMifQ==